import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@nextui-org/react'
import { IconPencil, IconPlus } from '@tabler/icons-react'
import moment from 'moment';
import React, { Fragment, useState } from 'react'
import Input from '../../components/Input';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateValidationSchema } from '../../utils/validationSchema';
import { useForm } from 'react-hook-form';
import { useApi } from '../../utils/ApiProvider'
import { snackbarToast } from '../../components/SnackbarToast'
import holidayQueries from '../../queries/holidayQueries';

const HolidayModal = ({children, title, selectedDate, item, isEdit}) => {

    const { setApiDataAndNotify } = useApi();

    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(true);
        if(isEdit){
            reset(item)
        }else{
            setValue('date', selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : '');
            setValue('color', '#4285F4');
        }
    }

    const handleClose = () => setIsOpen(false);
    const onOpenChange = () => {
        setIsOpen(!isOpen)
        reset()
    }
    

    const onSubmit = (data) => {
        if(data?.id){
            update.mutateAsync(data)
            handleClose()
        }else{
            create.mutateAsync(data)
            handleClose()
        }
    }

    const create = holidayQueries.useCreateHoliday(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
            }
            if(!res?.success){
                snackbarToast(res?.message, 'error')
            }
        }
    )

    const update = holidayQueries.useUpdateHoliday(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
            }
            if(!res?.success){
                snackbarToast(res?.message, 'error')
            }
        }
    )

    const inputFields = [
        {
            name: 'title',
            type: 'text',
            label: 'Title',
            placeholder: 'Title',
            required: true
        },
        {
            name: 'date',
            type: 'date',
            label: 'Date',
            placeholder: 'Date',
            required: true,
        }
    ]

    const {register, handleSubmit, formState: {errors}, setValue, watch, reset} = useForm({
        resolver: yupResolver(generateValidationSchema(inputFields))
    });

    const colorPalette = () => {

        const colorArray = [
            '#4285F4', '#FF6633', '#FFB399', '#FF33FF',
            '#00B3E6', '#E6B333', '#999966', '#99FF99'
        ];
    
        return (
            <div className='flex gap-2'>
                {
                    colorArray?.map((item, index) => {
                        return (
                            <div
                            onClick={() => setValue('color', item)}
                            key={index}
                            className='w-6 h-6 rounded-full bg-gray-200 cursor-pointer'
                            style={{backgroundColor: item, border: item === watch('color') ? `1px solid gray` : 'none'}}
                            />
                        )
                    })
                }
            </div>
        )
    }

  return (
    <>
        <button onClick={handleOpen} className={`outline-none focus:outline-none ${children && 'w-full'}`}>
            {
                children ? children :
                isEdit ?
                <IconPencil size="16" className='text-primary' />:
                <IconPlus size="16" className='text-primary' />
            }
        </button>
        <Modal 
        backdrop="opaque" 
        isOpen={isOpen} 
        onOpenChange={onOpenChange}
        classNames={{
            backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20"
        }}
        >
            <ModalContent>
            {(onClose) => (
                <Fragment>
                <ModalHeader className="flex flex-col gap-1">
                    {title}
                </ModalHeader>
                <ModalBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='text-[12px] flex flex-col gap-[6px]'>
                        {
                            inputFields?.map((item, index)=> {
                                return (
                                    <Input key={index} register={register} item={item} errors={errors} />
                                )
                            })
                        }
                        <div className='w-full'>
                            {colorPalette({setValue})}
                        </div>
                        <div className='w-full mt-2'>
                            <Button type='submit' className='w-full text-white bg-primary rounded-[7px] font-medium'>Save</Button>
                        </div>
                    </div>
                </form>
                </ModalBody>
                <ModalFooter />
                </Fragment>
            )}
            </ModalContent>
        </Modal>
    </>
  )
}

export default HolidayModal